import React, { ReactNode, useState } from 'react'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Text, Icon } from '@components'
import { Theme } from '@theme'
import { TabItem } from './TabItem'
import { useLanguage } from '@context'

interface TabSectionProps {
  firstTab: ReactNode
  secondTab: ReactNode
  rightAccessory?: ReactNode
}

export const TabSection: React.FC<TabSectionProps> = ({ firstTab, secondTab, rightAccessory }) => {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyle(theme)
  const [selectedTab, setSelectedTab] = useState<'first' | 'second'>('first')
  return (
    <View style={styles.container}>
      <View style={styles.tabContainer}>
        <View style={styles.tabItems}>
          <TabItem
            title={t('form.contactInfo')}
            isSelected={selectedTab === 'first'}
            onPress={() => setSelectedTab('first')}
          />
          <TabItem
            title={t('form.about')}
            isSelected={selectedTab === 'second'}
            onPress={() => setSelectedTab('second')}
          />
        </View>
        {rightAccessory && <View style={styles.rightAccessory}>{rightAccessory}</View>}
      </View>
      {selectedTab === 'first' && <View>{firstTab}</View>}
      {selectedTab === 'second' && secondTab}
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      marginHorizontal: theme.spacing.md,
    },
    tabContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.lg,
      marginVertical: theme.spacing.lg,
    },
    tabItems: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    rightAccessory: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  })
